// API-backed database helper for x2infotech frontend
/*const API_BASE = (import.meta.env.VITE_API_BASE_URL) || '/api';

async function request(path, options = {}) {
  const url = typeof path === 'string' && path.startsWith('http') ? path : `${API_BASE}/${path}`;
  const opts = Object.assign({ headers: {} }, options);
  if (!opts.headers['Content-Type'] && !(opts.body instanceof FormData)) {
    opts.headers['Content-Type'] = 'application/json; charset=utf-8';
  }
  if (opts.body && opts.headers['Content-Type'] && typeof opts.body !== 'string' && !(opts.body instanceof FormData)) {
    opts.body = JSON.stringify(opts.body);
  }
  const res = await fetch(url, opts);
  const json = await res.json().catch(() => null);
  if (!res.ok) throw new Error(json?.message || 'Request failed');
  return json;
}



export const dbHelpers = {
  // Auth
  async register(user) {
    return request('auth_register.php', { method: 'POST', body: user });
  },
  async login(payload) {
    return request('auth_login.php', { method: 'POST', body: payload });
  },
  async me(token) {
    const res = await fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/auth_me.php', {
      headers: { Authorization: 'Bearer ' + token }
    });
    return res.json();
  },

  // Users
  async getAllUsers(token) {
    const res = await fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/users_list.php', { headers: { Authorization: 'Bearer ' + token } });
    return res.json();
  },

  // Jobs
  async getJobs() {
    return request('jobs_list.php', { method: 'GET' });
  },
  async getActiveJobs() {
    return request('jobs_active.php', { method: 'GET' });
  },

  // Inquiries/contact
  async createInquiry(data) {
    return request('inquiries_create.php', { method: 'POST', body: data });
  },

  // Applications
  async applyToJob(data) {
    if (data instanceof FormData) {
      const url = (import.meta.env.VITE_API_BASE_URL || '/api') + '/applications_create.php';
      const res = await fetch(url, { method: 'POST', body: data });
      return res.json();
    } else {
      return request('applications_create.php', { method: 'POST', body: data });
    }
  },

  // Uploads (multipart)
  async uploadFile(file, type = 'document', token) {
    const fd = new FormData();
    fd.append('file', file);
    const url = (import.meta.env.VITE_API_BASE_URL || '/api') + '/uploads_' + (type === 'resume' ? 'resume' : (type === 'profile' ? 'profile' : 'document')) + '.php';
    const headers = token ? { Authorization: 'Bearer ' + token } : {};
    const res = await fetch(url, { method: 'POST', body: fd, headers });
    return res.json();
  },

  // Attendance (authenticated)
  async checkIn(data, token) {
    const url = (import.meta.env.VITE_API_BASE_URL || '/api') + '/attendance_checkin.php';
    const res = await fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type':'application/json', Authorization: 'Bearer ' + token } });
    return res.json();
  },
  async checkOut(data, token) {
    const url = (import.meta.env.VITE_API_BASE_URL || '/api') + '/attendance_checkout.php';
    const res = await fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type':'application/json', Authorization: 'Bearer ' + token } });
    return res.json();
  }
};

// Compatibility aliases for previous in-memory names
dbHelpers.getUserAttendance = async function(userId) {
  const token = localStorage.getItem('x2infotech_token');
  const res = await fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/attendance_list_user.php?user_id=' + encodeURIComponent(userId), {
    headers: { Authorization: 'Bearer ' + token }
  });
  return res.json();
};

dbHelpers.createAttendance = async function(data, token) {
  return dbHelpers.checkIn(data, token);
};

dbHelpers.updateAttendanceCheckout = async function(userId, date, checkOut, earlyLeaveReason, checkOutLocation) {
  const list = await dbHelpers.getUserAttendance(userId);
  if (!list || !list.data) return { status:false, message:'No attendance found' };
  const rec = list.data.find(r => r.date === date);
  if (!rec) return { status:false, message:'Record not found' };
  const token = localStorage.getItem('x2infotech_token');
  return dbHelpers.checkOut({ id: rec.id, check_out: checkOut }, token);
};

dbHelpers.updateAttendanceWorkingStatus = async function(userId, date, workingStatus) {
  // find attendance id for user/date via API (not ideal) - API expects id
  // We'll call attendance_list_user and try to find the record.
  const list = await dbHelpers.getUserAttendance(userId);
  if (!list || !list.data) return { status:false, message:'No attendance found' };
  const rec = list.data.find(r => r.date === date);
  if (!rec) return { status:false, message:'Record not found' };
  const token = localStorage.getItem('x2infotech_token');
  return fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/attendance_update_status.php', { method:'POST', headers: {'Content-Type':'application/json', Authorization: 'Bearer ' + token}, body: JSON.stringify({ id: rec.id, working_status: workingStatus }) }).then(r=>r.json());
};


export async function initializeDatabase() {
  // no-op for API-backed mode; kept for compatibility
  return true;
}

export default dbHelpers;


// Admin / management compatibility functions
dbHelpers.getAllUsers = async function(token) {
  const res = await fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/users_list.php', { headers: token ? { Authorization: 'Bearer ' + token } : {} });
  return res.json();
};
dbHelpers.getPendingUsers = async function(token) {
  const res = await fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/users_pending.php', { headers: token ? { Authorization: 'Bearer ' + token } : {} });
  return res.json();
};
dbHelpers.getAllJobs = async function() {
  return dbHelpers.getJobs();
};
dbHelpers.getAllInquiries = async function(token) {
  const res = await fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/inquiries_list.php', { headers: token ? { Authorization: 'Bearer ' + token } : {} });
  return res.json();
};
dbHelpers.createUser = async function(userData, token) {
  return fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/users_create.php', { method:'POST', headers: { 'Content-Type':'application/json', ...(token?{Authorization:'Bearer '+token}:{}) }, body: JSON.stringify(userData) }).then(r=>r.json());
};
dbHelpers.updateUser = async function(data, token) {
  return fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/users_update.php', { method:'POST', headers: { 'Content-Type':'application/json', ...(token?{Authorization:'Bearer '+token}:{}) }, body: JSON.stringify(data) }).then(r=>r.json());
};
dbHelpers.approveUser = async function(id, token) {
  return fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/users_approve.php', { method:'POST', headers: { 'Content-Type':'application/json', ...(token?{Authorization:'Bearer '+token}:{}) }, body: JSON.stringify({ id }) }).then(r=>r.json());
};
dbHelpers.rejectUser = async function(id, token) {
  return fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/users_reject.php', { method:'POST', headers: { 'Content-Type':'application/json', ...(token?{Authorization:'Bearer '+token}:{}) }, body: JSON.stringify({ id }) }).then(r=>r.json());
};
dbHelpers.deleteUser = async function(id, token) {
  return fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/users_delete.php', { method:'POST', headers: { 'Content-Type':'application/json', ...(token?{Authorization:'Bearer '+token}:{}) }, body: JSON.stringify({ id }) }).then(r=>r.json());
};

dbHelpers.createJob = async function(data, token) {
  return fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/jobs_create.php', { method:'POST', headers: { 'Content-Type':'application/json', ...(token?{Authorization:'Bearer '+token}:{}) }, body: JSON.stringify(data) }).then(r=>r.json());
};
dbHelpers.updateJob = async function(data, token) {
  return fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/jobs_update.php', { method:'POST', headers: { 'Content-Type':'application/json', ...(token?{Authorization:'Bearer '+token}:{}) }, body: JSON.stringify(data) }).then(r=>r.json());
};
dbHelpers.approveJob = async function(id, token) {
  return fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/jobs_approve.php', { method:'POST', headers: { 'Content-Type':'application/json', ...(token?{Authorization:'Bearer '+token}:{}) }, body: JSON.stringify({ id }) }).then(r=>r.json());
};
dbHelpers.rejectJob = async function(id, token) {
  return fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/jobs_reject.php', { method:'POST', headers: { 'Content-Type':'application/json', ...(token?{Authorization:'Bearer '+token}:{}) }, body: JSON.stringify({ id }) }).then(r=>r.json());
};
dbHelpers.deleteJob = async function(id, token) {
  return fetch((import.meta.env.VITE_API_BASE_URL || '/api') + '/jobs_delete.php', { method:'POST', headers: { 'Content-Type':'application/json', ...(token?{Authorization:'Bearer '+token}:{}) }, body: JSON.stringify({ id }) }).then(r=>r.json());
};*/








// API-backed database helper for x2infotech frontend

const API_BASE = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  ? 'http://localhost/x2infotech_full_integrated_project/api'
  : '/api';

/* =========================
   COMMON HELPERS
========================= */

const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem('x2infotech_token');
  const headers: Record<string, string> = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

async function request(path: string, options: any = {}) {
  const url = path.startsWith('http') ? path : `${API_BASE}/${path}`;

  const headers: any = {
    ...(options.headers || {}),
  };

  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const res = await fetch(url, {
    ...options,
    headers,
    body:
      options.body instanceof FormData
        ? options.body
        : options.body
        ? JSON.stringify(options.body)
        : undefined,
  });

  const json = await res.json().catch(() => null);

  if (!res.ok) {
    throw new Error(json?.message || 'Request failed');
  }

  return json;
}




/* =========================
   DB HELPERS
========================= */

export const dbHelpers = {
  /* -------- AUTH -------- */
  register(user: any) {
    return request('auth_register.php', { method: 'POST', body: user });
  },

  login(payload: any) {
    return request('auth_login.php', { method: 'POST', body: payload });
  },

  async me() {
    const res = await fetch(`${API_BASE}/auth_me.php`, {
      headers: getAuthHeaders(),
    });
    return res.json();
  },

  /* -------- USERS -------- */
  async getAllUsers() {
    const res = await fetch(`${API_BASE}/users_list.php`);
    return res.json();
  },

  async getPendingUsers() {
    const res = await fetch(`${API_BASE}/users_pending.php`, {
      headers: getAuthHeaders(),
    });
    return res.json();
  },

  /*async createUser(payload: any) {
  const response = await fetch(`${API_BASE}/users_create.php`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const text = await response.text();

  try {
    return JSON.parse(text);
  } catch {
    return { status: false, message: text };
  }
},*/
async createUser(payload: any, token?: string) {
  const headers: any = {
    'Content-Type': 'application/json',
  };

  const response = await fetch(`${API_BASE}/users_create.php`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });

  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch {
    return { status: false, message: text };
  }
},

  async updateUser(data: any) {
    const res = await fetch(`${API_BASE}/users_update.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(data),
    });
    return res.json();
  },

  async updateUserProfile(id: number | string, data: any) {
    const payload = {
      id,
      name: data.name,
      email: data.email,
      phone: data.phone,
      address: data.address,
      emergency_contact: data.emergencyContact || data.emergency_contact
    };
    const res = await fetch(`${API_BASE}/update-profile.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(payload),
    });
    return res.json();
  },

  async updateInquiryStatus(id: number | string, status: string) {
    const res = await fetch(`${API_BASE}/inquiries_update_status.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ id: Number(id), status }),
    });
    return res.json();
  },

  async getUserLeaveRequests(userId: number | string) {
    const res = await fetch(`${API_BASE}/hr_leaves.php`, {
      headers: getAuthHeaders(),
    });
    const json = await res.json();
    if (json.status && Array.isArray(json.data)) {
      return json.data
        .filter((l: any) => Number(l.user_id) === Number(userId))
        .map((l: any) => ({
          id: String(l.id),
          employeeId: l.user_id,
          leaveType: l.leave_type || 'casual',
          startDate: l.start_date,
          endDate: l.end_date,
          days: Math.ceil((new Date(l.end_date).getTime() - new Date(l.start_date).getTime()) / (1000 * 60 * 60 * 24)) + 1,
          reason: l.reason,
          status: l.status,
          appliedAt: l.created_at
        }));
    }
    return [];
  },

  async createLeaveRequest(data: any) {
    const payload = {
      user_id: data.employeeId,
      start_date: data.startDate,
      end_date: data.endDate,
      reason: data.reason,
      leave_type: data.leaveType
    };
    const res = await fetch(`${API_BASE}/hr_leaves.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(payload),
    });
    return res.json();
  },


  async approveUser(id: string, token?: string) {
    const payload = { id: parseInt(id, 10) };
    console.log('Approve payload:', payload);

    const res = await fetch(`${API_BASE}/users_approve.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify(payload),
    });
    return res.json();
  },

  async rejectUser(id: string, token?: string) {
    const payload = { id: parseInt(id, 10) };
    console.log('Reject payload:', payload);

    const res = await fetch(`${API_BASE}/users_reject.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify(payload),
    });
    return res.json();
  },

  async deleteUser(id: string) {
    const res = await fetch(`${API_BASE}/users_delete.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ id }),
    });
    return res.json();
  },

  /* -------- JOBS -------- */
  getJobs() {
    return request('jobs_list.php', { method: 'GET' });
  },

  getAllJobs() {
    return request('jobs_list.php', { method: 'GET' });
  },

  getActiveJobs() {
    return request('jobs_active.php', { method: 'GET' });
  },

  getApplications() {
    return request('applications_list.php', {
      method: 'GET',
      headers: getAuthHeaders()
    });
  },

  async applyToJob(data: any) {
    if (data instanceof FormData) {
      const res = await fetch(`${API_BASE}/applications_create.php`, {
        method: 'POST',
        body: data,
      });
      return res.json();
    } else {
      return request('applications_create.php', {
        method: 'POST',
        body: data,
      });
    }
  },

  createJob: async (payload: any) => {
    const res = await fetch(`${API_BASE}/jobs_create.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(payload),
    });

    return res.json();
  },

  async updateJob(data: any) {
    const res = await fetch(`${API_BASE}/jobs_update.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(data),
    });
    return res.json();
  },

  async approveJob(id: string) {
    const res = await fetch(`${API_BASE}/jobs_approve.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ id }),
    });
    return res.json();
  },

  async rejectJob(id: string) {
    const res = await fetch(`${API_BASE}/jobs_reject.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ id }),
    });
    return res.json();
  },

  async deleteJob(id: string) {
    const res = await fetch(`${API_BASE}/jobs_delete.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ id }),
    });
    return res.json();
  },

  /* -------- DOCUMENTS -------- */
async getUserDocuments() {
  const res = await fetch(
    `${API_BASE}/uploads_list.php`,
    {
      headers: {
        ...getAuthHeaders(), // 🔐 token
      },
    }
  );
  return res.json();
},


  /* -------- INQUIRIES -------- */
  createInquiry(data: any) {
    return request('inquiries_create.php', { method: 'POST', body: data });
  },

  async getAllInquiries() {
    const res = await fetch(`${API_BASE}/inquiries_list.php`, {
      headers: getAuthHeaders(),
    });
    return res.json();
  },

  /* -------- ATTENDANCE -------- */
    async getAllAttendance() {
    const res = await fetch(`${API_BASE}/attendance_list_all.php`, {
      headers: {
        ...getAuthHeaders(), // 🔐 admin token
      },
    });

    return res.json();
  },

  async checkIn(data: any) {
    const res = await fetch(`${API_BASE}/attendance_checkin.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(data),
    });
    return res.json();
  },

  async checkOut(data: any) {
    const res = await fetch(`${API_BASE}/attendance_checkout.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(data),
    });
    return res.json();
  },

  async getUserAttendance(userId: string) {
    const res = await fetch(
      `${API_BASE}/attendance_list_user.php?user_id=${encodeURIComponent(userId)}`,
      { headers: getAuthHeaders() }
    );
    return res.json();
  },

  async updateAttendanceCheckout(
    userId: string,
    date: string,
    checkOut: string,
    earlyLeaveReason: string,
    checkOutLocation: string,
    id?: string
  ) {
    // Find the attendance record id
    const list = await this.getUserAttendance(userId);
    if (!list || !list.data) return { status: false, message: 'No attendance found' };
    const rec = list.data.find((r: any) => r.date === date);
    if (!rec) return { status: false, message: 'Record not found' };

    const res = await fetch(`${API_BASE}/attendance_checkout.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({
        id: rec.id,
        check_out: checkOut,
        early_leave_reason: earlyLeaveReason,
        check_out_location: checkOutLocation,
      }),
    });
    return res.json();
  },

  async updateAttendanceWorkingStatus(
    userId: string,
    date: string,
    workingStatus: string
  ) {
    try {
      // Find the attendance record id
      const list = await this.getUserAttendance(userId);
      if (!list || !list.data) return { status: false, message: 'No attendance found' };
      const rec = list.data.find((r: any) => r.date === date);
      if (!rec) return { status: false, message: 'Record not found' };

      const res = await fetch(`${API_BASE}/attendance_update_status.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders(),
        },
        body: JSON.stringify({
          id: rec.id,
          working_status: workingStatus,
        }),
      });

      const text = await res.text();
      let json;

      try {
        json = JSON.parse(text);
      } catch (e) {
        console.error('API returned HTML instead of JSON:', text.substring(0, 200));
        return { status: false, message: 'Server error - invalid response' };
      }

      return json;
    } catch (error) {
      console.error('Fetch error:', error);
      return { status: false, message: 'Network error' };
    }
  },


  
  /* -------- FILE UPLOAD -------- */
  async uploadFile(fileOrFormData: File | FormData, type = 'document') {
    if (type === 'resume') {
      return this.uploadResume(fileOrFormData);
    }

    let body: FormData;
    if (fileOrFormData instanceof FormData) {
      body = fileOrFormData;
    } else {
      body = new FormData();
      body.append('file', fileOrFormData);
    }

    const endpoint = type === 'profile' ? 'uploads_profile.php' : 'uploads_document.php';
    const res = await fetch(`${API_BASE}/${endpoint}`, {
      method: 'POST',
      headers: {
        ...getAuthHeaders(),
      },
      body,
    });

    const text = await res.text();
    try {
      return JSON.parse(text);
    } catch {
      console.error('Backend returned non-JSON:', text);
      return { status: false, message: 'Server error during upload' };
    }
  },

  async uploadResume(fileOrFormData: File | FormData) {
    let body: FormData;
    if (fileOrFormData instanceof FormData) {
      body = fileOrFormData;
    } else {
      body = new FormData();
      body.append('file', fileOrFormData);
    }

    const res = await fetch(`${API_BASE}/uploads_resume.php`, {
      method: 'POST',
      body, // Public upload, no auth required
    });

    const text = await res.text();
    try {
      return JSON.parse(text);
    } catch {
      console.error('Backend returned non-JSON:', text);
      return { status: false, message: 'Server error during resume upload' };
    }
  },

  /* -------- HR -------- */
  async getHREmployees() {
    const res = await fetch(`${API_BASE}/hr_employees.php`, {
      headers: getAuthHeaders(),
    });
    return res.json();
  },

  async addHREmployee(data: any) {
    const res = await fetch(`${API_BASE}/hr_employees.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify(data),
    });
    return res.json();
  },

  async getHRLeaves() {
    const res = await fetch(`${API_BASE}/hr_leaves.php`, {
      headers: getAuthHeaders(),
    });
    return res.json();
  },

  async applyHRLeave(data: any) {
    const res = await fetch(`${API_BASE}/hr_leaves.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify(data),
    });
    return res.json();
  },

  async updateHRLeaveStatus(id: number, status: string) {
    const res = await fetch(`${API_BASE}/hr_leaves.php`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify({ id, status }),
    });
    return res.json();
  },

  async getHRPayroll() {
    const res = await fetch(`${API_BASE}/hr_payroll.php`, {
      headers: getAuthHeaders(),
    });
    return res.json();
  },

  async addHRPayroll(data: any) {
    const res = await fetch(`${API_BASE}/hr_payroll.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify(data),
    });
    return res.json();
  },

  // Invoices & Billing
  async getInvoices() {
    const res = await fetch(`${API_BASE}/invoices.php`, {
      headers: getAuthHeaders(),
    });
    return res.json();
  },

  async getInvoiceById(id: number | string) {
    const res = await fetch(`${API_BASE}/invoices.php?id=${id}`, {
      headers: getAuthHeaders(),
    });
    return res.json();
  },

  async createInvoice(data: any) {
    const res = await fetch(`${API_BASE}/invoices.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify(data),
    });
    return res.json();
  },

  async updateInvoice(id: number | string, data: any) {
    const res = await fetch(`${API_BASE}/invoices.php`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify({ ...data, id }),
    });
    return res.json();
  },

  async approveInvoice(id: number | string) {
    const res = await fetch(`${API_BASE}/invoices.php?action=approve`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify({ id }),
    });
    return res.json();
  },

  async rejectInvoice(id: number | string, reason: string) {
    const res = await fetch(`${API_BASE}/invoices.php?action=reject`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify({ id, reason }),
    });
    return res.json();
  },

  async deleteInvoice(id: number | string) {
    const res = await fetch(`${API_BASE}/invoices.php?id=${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    return res.json();
  },
};





/* =========================
   INIT (NO-OP)
========================= */

export async function initializeDatabase() {
  return true;
}

export default dbHelpers;